module.exports = __webpack_public_path__ + "img/11s.02af5414.png";